import ApiService from '@/core/services/api.service';
import { cmdUrl } from '@/utils/apiUrl';
import { AMOUNT_TYPE } from '@/utils/enum';
import { labelsFromDiscountProgramApi } from '@/utils/discountProgramDisplay';
import { hasVoucherOnLine, setProgramOnlySplitAmounts } from '@/utils/voucherDiscountStack';

/**
 * Auto-apply product discount program (same API as BillProduct.getProductDiscount).
 * Expects `storeId` and item with `productId`, `sellingPriceMask` / `sellingPrice`, `id`.
 */
export default {
  methods: {
    async applyProductDiscountProgram(productItem, storeId) {
      if (!storeId || !productItem?.productId) {
        return;
      }
      const target = productItem;
      if (target.discountProgramId) {
        return;
      }
      const query = {
        params: {
          productIds: [target.productId],
        },
      };
      await ApiService.query(
        cmdUrl.DiscountProgramUrl.byProduct +
          `/${target.productId}` +
          `/${storeId}`,
        query,
      ).then((response) => {
        if (response.data.status !== 1) {
          return;
        }
        const discountProgram = response.data.data;
        if (!discountProgram || discountProgram.length === 0) {
          return;
        }
        const productDiscountProgram = discountProgram.find(
          (item) => String(item.productId) === String(target.productId),
        );
        if (!productDiscountProgram) {
          return;
        }
        const discountType = Number(productDiscountProgram.discountType || 1);
        const discountAmount = Number(productDiscountProgram.discountAmount || 0);
        const maxValue = Number(productDiscountProgram.maxValue || 0);
        const sellingPrice = Number(
          target.sellingPriceMask || target.sellingPrice || 0,
        );
        const discountAmountByPercent = (sellingPrice * discountAmount) / 100;
        const isPercentOverMax =
          discountType === AMOUNT_TYPE.PERCENT &&
          maxValue > 0 &&
          discountAmountByPercent > maxValue;

        target.discountType = isPercentOverMax ? AMOUNT_TYPE.MONEY : discountType;
        target.discountAmount = isPercentOverMax ? maxValue : discountAmount;
        this.$set(target, 'maxValue', maxValue);
        this.$set(
          target,
          'discountProgramId',
          Number(productDiscountProgram.id) || null,
        );
        const { code, name } = labelsFromDiscountProgramApi(productDiscountProgram);
        this.$set(target, 'promotionProgramCode', code);
        this.$set(target, 'promotionProgramName', name);
        this.$set(target, 'isOverMaxValue', isPercentOverMax ? 1 : 0);
        this.$set(
          target,
          'originalPercentDiscountAmount',
          discountType === AMOUNT_TYPE.PERCENT ? discountAmount : 0,
        );
        if (!hasVoucherOnLine(target)) {
          setProgramOnlySplitAmounts(target);
        }
      });
    },
  },
};
